var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('homeNav',[_c('div',{staticClass:"main-container"},[_c('Menu'),_c('YlCarousel'),_c('UserNav')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }